import { Component, Show, Switch, Match, createSignal } from "solid-js";
import { A } from "../components/universal/a-href";
import { Img } from "../components/universal/image";
import { FacebookShareButton } from "../components/social-media-share-buttons/facebook-share-button";
import { PinterestShareButton } from "../components/social-media-share-buttons/pinterest-share-button";
import { TwitterShareButton } from "../components/social-media-share-buttons/twitter-share-button";
import { AddToCollectionModal } from "../components/add-to-collection-modal";
import { Artwork, UserSession } from "../types";

type Props = {
    artwork: Artwork;
    session: UserSession;
}

export const DetailsTab : Component<Props> = ({ artwork, session } ) => {
    const [showModal, setShowModal] = createSignal<boolean>(false);
    const [liked, setLiked] = createSignal<boolean>(false);
    const showAddToCollectionModal = () => {
        setShowModal(true);
    }
    const closeAddToCollectionModal = () => {
        setShowModal(false);
    }
    return (
        <>
            <div class="didactic" style="margin: 0; width: 100%; background-color: #fff;">
                <div class="action-buttons">
                    <Show when={session.isLoggedIn}>
                        <div class="social-media-button" style="color: goldenrod;">
                            <span class="fa fa-star" onClick={(e) => { e.preventDefault(); showAddToCollectionModal() }}></span>
                        </div>
                    </Show>
                    <div class="social-media-button">
                        <FacebookShareButton artwork={artwork} />
                    </div>
                    <div class="social-media-button">
                        <PinterestShareButton artwork={artwork} />
                    </div>
                    <div class="social-media-button">
                        <TwitterShareButton artwork={artwork} />
                    </div>
                </div>
                <Show when={artwork.artist.autograph}>
                    <p style="text-align: center;">
                        <a href={ `/artists/${artwork.artist.slug}/${artwork.artist.id}` }>
                            <Img style="margin: 0 auto;" src={ artwork.artist.autograph.url } height={100} />
                        </a>
                    </p>
                </Show>
                <p class="artist-name">
                    <A href={ `/artists/${artwork.artist.slug}/${artwork.artist.id}` }>
                        {artwork.artist.firstName} {artwork.artist.lastName}
                    </A>
                </p>
                <p class="artist-years">
                    {artwork.artist.dateRange}
                </p>
                <p>
                    <Show when={artwork.artist.nationalities}>
                        <span style="margin-right: 5px;">{artwork.artist.nationalities}</span>
                    </Show>
                    <Show when={artwork.artist.movements}>
                        <span style="margin-right: 5px;">{artwork.artist.movements}</span>
                    </Show>
                    <Show when={artwork.artist.professions}>
                        <span style="margin-right: 5px;">{artwork.artist.professions}</span>
                    </Show>
                </p>
                <p class="artwork-title" innerHTML={artwork.title}></p>
                <Show when={!!artwork.translatedTitle}>
                    <p style="font-size: 1.5rem;" innerHTML={artwork.translatedTitle}></p>
                </Show>
                <Show when={!!artwork.alternateTitle}>
                    <p style="font-size: 1.5rem;" innerHTML={artwork.alternateTitle}></p>
                </Show>
                <p class="artwork-dates">
                    <strong>{artwork.dateRange}</strong>
                </p>
                <p class="artwork-properties">
                    <span innerHTML={artwork.measurements}></span><br />
                    {artwork.medium}
                </p>
                <Show when={artwork.artworkLocation?.isPublic}>
                    <p class="artwork-location-name">
                        <a href={ "/ArtCollection/Index/" + artwork.artworkLocation?.id }>
                            <span innerHTML={artwork.artworkLocation?.name}></span>
                        </a>
                    </p>
                    <p class="artwork-location-address">
                        {artwork.artworkLocation?.city}
                        <Show when={artwork.artworkLocation?.country}>
                            | {artwork.artworkLocation?.country}
                        </Show>
                    </p>
                </Show>
                <Show when={artwork.content}>
                    <div class="artwork-image-credit" innerHTML={artwork.content}></div>
                </Show>
                <Show when={artwork.credit}>
                    <div class="artwork-image-credit" innerHTML={artwork.credit}></div>
                </Show>
                <Show when={artwork.primaryImage.description}>
                    <div class="artwork-image-credit" innerHTML={artwork.primaryImage.description}></div>
                </Show>
                <Switch>
                    <Match when={artwork.isForSale}>
                        <p>
                            <a href={"/Artwork/Enquire?artworkId="+ artwork.id + "&campaign=ARCArtwork"} class="btn btn-chunky-lg btn-chunky-goldenrod">Enquire about this work</a>
                        </p>
                    </Match>
                    <Match when={artwork.isSold}>
                        <h3>
                            <span style="color: red;border: 1px solid red; padding: 0 5px; border-radius: 5px;">SOLD</span>
                        </h3>
                    </Match>
                </Switch>
                <Show when={artwork.gallery}>
                    <div>
                        <h4>
                            {artwork.gallery!.name}
                        </h4>
                        <div innerHTML={artwork.gallery!.shortDescription}></div>
                    </div>
                </Show>
                <AddToCollectionModal artworkId={artwork.id.toString()} showModal={showModal} onClose={closeAddToCollectionModal} />
            </div>
        </>
    )
}